import {useInfiniteQuery} from '@tanstack/react-query'
import {apiGetNotifications, INavNotification} from '@api/user/account/notification/getNotification'
import {QueryCacheKeys} from '@hook/query/queryKeys'

const PAGE_SIZE = 30
const useQueryNotification = (id?: string, refetchEnabled: boolean = false) => {
    const {data, refetch, isLoading, isFetchingNextPage, fetchNextPage} = useInfiniteQuery({
        queryKey: QueryCacheKeys.notification.getNotificationsList(id),
        refetchOnWindowFocus: false,
        staleTime: 10 * 1000,
        refetchInterval: refetchEnabled && 10 * 1000,
        queryFn: async ({pageParam}) => {
            const {data} = await apiGetNotifications(PAGE_SIZE, pageParam ?? 0)
            if (data) return data
            return [] as INavNotification[]
        },
        getNextPageParam: (lastPage, allPages) => allPages?.reduce((a, b) => a + b?.length, 0),
    })

    const isEmpty = data?.pages?.at(0)?.length === 0
    const isReachingEnd = isEmpty || (data && data?.pages?.at(-1)?.length < PAGE_SIZE)

    return {data, refetch, isLoading, isFetchingNextPage, fetchNextPage, isReachingEnd}
}

export default useQueryNotification
